import React from 'react'
import Provider from './Provider'
import { IMediaPageProps } from './Interfaces'
import { Box, useMediaQuery } from '@material-ui/core'
import { Section } from 'components'
import useStyles from './Styles'
import SelectMedialFilePanel from './components/SelectFilePanel'
import CurrentMediaPanel from './components/CurrentMediaPanel'
import LinkPanel from './components/LinkPanel'

const MediaPage: React.FC<IMediaPageProps> = ({
  state,
  setFile,
  onDeleteFile,
  doUpload,
  clearFile,
  medias,
  onChangeLinkName,
  onChangeLinkUrl,
  doSave,
  onDeleteLink
}) => {
  const classes = useStyles({})

  const isSmall = useMediaQuery('(max-width:834px)')

  const file = medias.find(media => media.mediaType === 'FILE')
  const links = medias.filter(media => media.mediaType === 'LINK')

  return (
    <Box className={classes.root}>
      <Section padding="50px 40px 30px 40px" direction={'column'}>
        {medias && medias.length ? (
          <CurrentMediaPanel
            isSmall={isSmall}
            file={
              file
                ? {
                    onDelete: onDeleteFile,
                    url: file.url,
                    name: file.name,
                    isSaving: state.isUploading
                  }
                : null
            }
            links={
              links && links.length
                ? {
                    onDelete: onDeleteLink,
                    items: links,
                    isSaving: state.isSavingLink
                  }
                : null
            }
          />
        ) : null}
        {!file && (
          <SelectMedialFilePanel
            isUploading={state.isUploading}
            clearFile={clearFile}
            doUpload={doUpload}
            error={state.error}
            file={state.file}
            setFile={setFile}
          />
        )}
        {(!links || !links.length || links.length < 3) && (
          <LinkPanel
            error={!state.isLinkUrlValid}
            linkUrl={state.linkUrl}
            linkName={state.linkName}
            saveLink={doSave}
            onChangeLinkName={onChangeLinkName}
            onChangeLinkUrl={onChangeLinkUrl}
            isSavingLink={state.isSavingLink}
          />
        )}
      </Section>
    </Box>
  )
}

export default () => <Provider>{(viewProps: IMediaPageProps) => <MediaPage {...viewProps} />}</Provider>
